export interface PatientAccounts {
    rendered_amount: string;
    created_at: string;
    name: string;
    medical_record_number: string;
    country_name: string;
    consultation_name: string;
    transaction_no: string;
    status: string;
    rendered_actual_amount: string;
    sr_no: number;
    invoice: {
        invoice_id: string;
        invoice_key: string;
        invoice_url: string;
    };
    invoice_id: string;
    patient_guid: string;
    id: string;
    payment_id: string;
    payment_gateway: string;
    is_package: boolean;
    isConsultationNotClosed: boolean;
    isDietConsultation: boolean;
    con_status: string;
}

export interface DoctorAccounts {
    sr_no: number;
    consultation: string;
    doctor_name: string;
    specialty_name: string;
    priority_type: string;
    created_at: string;
    patient_name: string;
    country_name: string;
    transaction_no: string;
    transaction_status: string;
    rendered_amount: string;
    rendered_actual_amount: string;
}

export class patientRefundList {
    sr_no: number;
    refund_id: string;
    refund_type: string;
    refund_actual_amount: string;
    refund_discounted_amount: string;
    refund_amount: string;
    audited_by_user_name: string;
    created_at: string;
    refund_status: string;
}

export enum refund_status_enum {
    initialized = 1,
    inprogress = 2,
    approved = 3,
    rejected = 4
}

export class refund_sanction_body {
    refund_id: string;
    approve: boolean;
}

export class patientRefundBody {
    transaction_id: string;
    refund_reason: string;
}

export class refundBody extends patientRefundBody {
    is_auto: boolean;
    refund_percent: number;
}

export class refundData {
    data: {
        amount: number;
        refund_type: string;
        status_id: number;
        audited_by_user_guid: string;
        audited_by_user_name: string;
        audited_at: string;
        created_at: string;
        updated_at: string;
        refund_id: string;
        p_cancellations: {
            reason: string;
            p_transactions: {
                transaction_no: number;
                amount: number;
                currency_type: string;
                created_at: string;
                payment_gateway_type: string;
                p_consultation?: {
                    consultation_request_number: string;
                    created_at: string;
                };
                p_accounts: {
                    first_name: string;
                    middle_name: string;
                    last_name: string;
                    medical_record_number: number;
                };
                paypal?: {
                    paypal_transaction_id: string;
                };
                razor_pay?: {
                    payment_id: string;
                };
            };
            refund_audit: {
                id: number;
                egd_users?: {
                    first_name: string;
                    middle_name: string;
                    last_name: string;
                };
                p_accounts?: {
                    first_name: string;
                    middle_name: string;
                    last_name: string;
                    medical_record_number: number;
                };
            };
        };
        refund_status: {
            status: string;
        };
        paypal_refund?: {
            refund_id: string;
            paypal_transaction_id: string;
            is_settled: boolean;
            created_at: string;
            paypal_refund_status_audit: [
                {
                    id: number;
                    paypal_refund_id: string;
                    braintree_processor_response_code: string;
                    braintree_processor_response_text: string;
                    braintree_transaction_status: string;
                    created_at: string;
                    updated_at: string;
                }
            ];
        };
        razorpay_refund: {
            refund_id: string;
            razorpay_refund_transaction_id: string;
            acquirer_data: {
                arn: null;
            };
            created_at: string;
            razorpay_refund_status_audit: [
                {
                    id: 1;
                    razorpay_refund_id: string;
                    status: string;
                    created_at: string;
                    updated_at: string;
                }
            ];
        };
    };
    transaction_amount: string;
    refund_amount: string;
}
